import markLight from '@immigranta/ui/assets/immigranta-icon.png'
import markDark from '@immigranta/ui/assets/immigranta-icon-dark.png'

interface LogoProps {
  className?: string
  /** Visual size of the lockup. `default` matches the marketing navbar. */
  size?: 'default' | 'sm'
}

const sizes = {
  default: { mark: 'h-10', text: 'text-3xl' },
  sm: { mark: 'h-8', text: 'text-xl' },
} as const

/**
 * Brand lockup: the Immigranta mark + live "Immigranta" wordtext.
 *
 * Replaces the old baked-in wordmark PNGs. The text is real text (Manrope
 * bold) so it stays crisp at any DPI and themes itself — `text-brand` navy
 * in light mode, white in dark mode — instead of shipping a separate
 * light/dark text image. Only the mark swaps per theme: the deeper-purple
 * mark in light mode, the brighter-violet mark in dark mode, via Tailwind's
 * `dark:hidden` / `hidden dark:block` (same swap pattern as the marketing
 * `Logo.astro`). Both marks come from `@immigranta/ui` so marketing and
 * webapp drink from the same source.
 */
export function Logo({ className = '', size = 'default' }: LogoProps) {
  const { mark, text } = sizes[size]
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <img src={markLight} alt="" aria-hidden className={`${mark} w-auto block dark:hidden`} />
      <img src={markDark} alt="" aria-hidden className={`${mark} w-auto hidden dark:block`} />
      <span className={`font-bold leading-none tracking-tight text-brand dark:text-white ${text}`}>
        Immigranta
      </span>
    </span>
  )
}
